
const digest = '77d85d2545de360d369e98c356917edcb21c9ba25568d38b3da43ea61530f78b';
const classes = {"wrapper":"_wrapper_4gta5_1"};
const css = `._wrapper_4gta5_1 {
  display: flex;
  padding: 12px;
  background-color: #fff;
  border: 1px solid #eaedf3;
  gap: 24px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  